import React from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
// import Conf1 from "../../img/conf1.png";
import Conf3 from "../../img/conf3.png";
import Conf2 from "../../img/conf2.png";
const Portfolio = () => {
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span className="blued">Conférences</span>
      <span className="blued">E-Medisys / I3M / NDIDO</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >

       
        <SwiperSlide>
          <img src={Conf2} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Conf3} alt="" />
        </SwiperSlide>
        {/* <SwiperSlide>
          <img src={Conf1} alt="" />
        </SwiperSlide> */}
        <SwiperSlide>
          <img src={Conf2} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Conf3} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Conf2} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Conf3} alt="" />
        </SwiperSlide>
        {/* <SwiperSlide>
          <img src={Conf1} alt="" />
        </SwiperSlide> */}
        <SwiperSlide>
          <img src={Conf2} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Conf3} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
